/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { ErrorType } from '../../axios';
import { request } from '../../axios';
import type { GetHistoryParams, HistoryDto } from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getHistory = (
  params: GetHistoryParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<HistoryDto[]>({ url: `/api/history`, method: 'GET', params, signal }, options);
};

export const getGetHistoryQueryKey = (params: GetHistoryParams) => {
  return [`/api/history`, ...(params ? [params] : [])] as const;
};

export const getGetHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHistory>>> = ({ signal }) =>
    getHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getHistory>>>;
export type GetHistoryQueryError = ErrorType<unknown>;

export function useGetHistory<TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHistory<TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHistory<TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHistory<TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetHistorySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getHistory>>,
  TError = ErrorType<unknown>,
>(
  params: GetHistoryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHistoryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHistory>>> = ({ signal }) =>
    getHistory(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetHistorySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getHistory>>>;
export type GetHistorySuspenseQueryError = ErrorType<unknown>;

export function useGetHistorySuspense<TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHistorySuspense<TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHistorySuspense<TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetHistorySuspense<TData = Awaited<ReturnType<typeof getHistory>>, TError = ErrorType<unknown>>(
  params: GetHistoryParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getHistory>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHistorySuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
